const sagaActions = {
  FETCH_BOX: 'FETCH_BOX',
  FETCH_BOX_STOP: 'FETCH BOX STOP',
};
export default sagaActions;
